import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getProfile } from "../../utils/backend";
import { CSpinner } from "@coreui/react-pro";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const ViewProfile = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [admin, setAdmin] = useState({});
  const { id } = useParams();

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const response = await getProfile();
      setAdmin(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
      setAdmin({});
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {/* <h5 className="mb-3">Profile</h5> */}
      {isLoading ? (
        <div className="card border-light">
          <div className="card-body p-4">
            <div className="row">
              <div className="col-md-6 mb-3">
                <Skeleton height={25} width={100} />
                <Skeleton height={25} width={150} />
              </div>
              <div className="col-md-6 mb-4">
                <Skeleton height={25} width={100} />
                <Skeleton height={25} width={150} />
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 mb-3">
                <Skeleton height={25} width={100} />
                <Skeleton height={25} width={150} />
              </div>
              <div className="col-md-6 mb-4">
                <Skeleton height={25} width={100} />
                <Skeleton height={25} width={150} />
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 mb-3">
                <Skeleton height={25} width={100} />
                <Skeleton height={25} width={150} />
              </div>
              <div className="col-md-6 mb-4">
                <Skeleton height={25} width={100} />
                <Skeleton height={25} width={150} />
              </div>
            </div>
            <div className="d-flex justify-content-end">
              <Skeleton height={40} width={100} />
            </div>
          </div>
        </div>
      ) : (
        <div className="card border-light">
          <div className="card-body p-4">
            <div className="row">
              <div className="col-md-6 mb-3">
                <label className="form-label">ID</label>
                <p>
                  <b>{admin.id}</b>
                </p>
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">Username</label>
                <p>
                  <b>{admin.username}</b>
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 mb-3">
                <label className="form-label">Role</label>
                <p>
                  <b>{admin.role}</b>
                </p>
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">Email</label>
                <p>
                  <b>{admin.email}</b>
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 mb-3">
                <label className="form-label">Phone Number</label>
                <p>
                  <b>{admin.phone_number}</b>
                </p>
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">Full Name</label>
                <p>
                  <b>{admin.full_name}</b>
                </p>
              </div>
            </div>
            <div className="d-flex justify-content-end">
              {window.location.pathname.includes("/dashboard") ? (
                <>
                  <button
                    type="button"
                    className="btn me-3 ansa-button-secondary"
                    onClick={() => navigate(`/dashboard`)}
                  >
                    Back
                  </button>
                  <button
                    type="button"
                    className="btn ansa-button-primary"
                    onClick={() => navigate(`/dashboard/profile/edit`)}
                  >
                    Edit
                  </button>
                </>
              ) : (
                <>
                  <button
                    type="button"
                    className="btn ansa-button-primary"
                    onClick={() => navigate(`/profile/edit`)}
                  >
                    Edit
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ViewProfile;
